const TITLE_THAI_PATTERN = /[^ก-๛\s.]+/g;
const TITLE_ENGLISH_PATTERN = /[^A-Za-z\s.]+/g;

export const CA_FAILURE_MESSAGE = 'ขอใบรับรองอิเล็กทรอนิกส์(CA) ไม่สำเร็จ';

export const buildCAPayload = (oneIdResult, business_id) => {
  const { request, response } = oneIdResult;

  return {
    account_id: response.data.account_id,
    biz_id: business_id,
    address: request.address,
    ou: request.sub_organization,
    t: request.position,
    o: request.organization,
    special_title_th: request.special_title_th
      ? request.special_title_th.replace(TITLE_THAI_PATTERN, '')
      : null,
    special_title_eng: request.special_title_eng
      ? request.special_title_eng.replace(TITLE_ENGLISH_PATTERN, '')
      : null,
    attorney: !!request.maintainer_name_1,
    maintainer_name_1: request.maintainer_name_1,
    maintainer_surname_1: request.maintainer_surname_1,
    maintainer_email_1: request.maintainer_email_1,
    maintainer_tel_1: request.maintainer_tel_1,
    maintainer_name_2: request.maintainer_name_2,
    maintainer_surname_2: request.maintainer_surname_2,
    maintainer_email_2: request.maintainer_email_2,
    maintainer_tel_2: request.maintainer_tel_2,
    maintainer_name_3: request.maintainer_name_3,
    maintainer_surname_3: request.maintainer_surname_3,
    maintainer_email_3: request.maintainer_email_3,
    maintainer_tel_3: request.maintainer_tel_3,
    maintainer_name_4: request.maintainer_name_4,
    maintainer_surname_4: request.maintainer_surname_4,
    maintainer_email_4: request.maintainer_email_4,
    maintainer_tel_4: request.maintainer_tel_4,
    idCard: request.cid
      ? request.cid.toString().replaceAll(' ', '').replaceAll('-', '')
      : null,
    mobile: request.mobile
      ? request.mobile.toString().replaceAll(' ', '')
      : null,
    email: request.email
      ? request.email.toString().replaceAll(' ', '')
      : null,
  };
};

export const buildCAFailResponse = (error) => {
  const caError = error?.response?.data;
  return caError && typeof caError === 'object'
    ? caError
    : { message: error?.message || CA_FAILURE_MESSAGE, data: null, error: null };
};
